import { IsArray, IsEnum, IsNumber, IsObject } from "class-validator";
import { Product } from "../models/models";
import type { FeesModel } from "../models/product.model";
export class RequestAddOnDto {
  @IsNumber()
  apiKeyCount!: number;

  @IsNumber()
  applicationCount!: number;

  @IsNumber()
  userCount!: number;
}
export class AddOnItemDto {
  @IsNumber()
  count!: number;

  @IsNumber()
  totalPrice?: number;

  @IsNumber()
  monthlyPrice: number;

  @IsNumber()
  discountedPrice?: number;

  constructor(count: number, totalPrice = 0, monthlyPrice = 0, discountedPrice = 0) {
    this.count = count;
    this.totalPrice = totalPrice;
    this.monthlyPrice = monthlyPrice;
    this.discountedPrice = discountedPrice;
  }
}

export class GetAddonItemWithoutPriceDto {
  @IsNumber()
  apiKey!: number;

  @IsNumber()
  application!: number;

  @IsNumber()
  user!: number;

  constructor(partial: Partial<GetAddonItemWithoutPriceDto>) {
    Object.assign(this, partial);
  }
}

export class GetAddOnDto {
  @IsObject()
  apiKey!: AddOnItemDto;

  @IsObject()
  application!: AddOnItemDto;

  @IsObject()
  user!: AddOnItemDto;

  constructor(partial: Partial<GetAddOnDto>) {
    Object.assign(this, partial);
  }
}

export class ProductConfigurationDto {
  @IsEnum(Product)
  product!: Product;

  @IsNumber()
  callLimit!: number;

  @IsNumber()
  rps!: number;

  constructor(partial: Partial<ProductConfigurationDto>) {
    Object.assign(this, partial);
  }
}

export class ProductConfigurationPriceDto extends ProductConfigurationDto {
  @IsNumber()
  totalPrice!: number;

  @IsNumber()
  monthlyPrice!: number;

  @IsNumber()
  discountedPrice?: number;

  constructor(partial: Partial<ProductConfigurationPriceDto>) {
    super(partial);
    Object.assign(this, partial);
  }
}

export class ProductConfigurationPriceOverviewDto {
  @IsArray()
  productConfig!: ProductConfigurationPriceDto[];

  @IsNumber()
  totalPrice!: number;

  @IsNumber()
  totalDiscountedPrice?: number;

  @IsNumber()
  monthlyPrice!: number;

  @IsNumber()
  callsDiscount!: number;

  @IsNumber()
  billingIntervalDiscount!: number;

  @IsObject()
  fees: FeesModel = {
    stablePairFee: 0,
    normalPairFee: 0
  };

  constructor(partial: Partial<ProductConfigurationPriceOverviewDto>) {
    Object.assign(this, partial);
  }
}

export class SubscriptionAddOnPriceOverviewDto {
  addOnConfig!: GetAddOnDto;

  @IsNumber()
  totalPrice!: number;

  @IsNumber()
  discountedPrice?: number;

  @IsNumber()
  monthlyPrice!: number;

  @IsNumber()
  billingIntervalDiscount!: number;

  constructor(partial: Partial<SubscriptionAddOnPriceOverviewDto>) {
    Object.assign(this, partial);
  }
}

export class SubscriptionQuoteDto {
  @IsNumber()
  totalPrice!: number;

  @IsNumber()
  totalDiscountedPrice!: number;

  @IsNumber()
  monthlyPrice!: number;

  @IsNumber()
  callsDiscount!: number;

  @IsNumber()
  billingIntervalDiscount!: number;

  constructor(partial: Partial<SubscriptionQuoteDto>) {
    Object.assign(this, partial);
  }
}
